export * from "./authentication";
export * from "./shifts";
export * from "./orders";
export * from "./reservations";
export * from "./customers";
export * from "./tables";
export * from "./settings";
export * from "./marketing";
export * from "./zones";
export * from "./artefacts";
export * from "./feedbacks";



// WEBPACK FOOTER //
// ./src/successes/index.js